import React, { useState } from "react";
import { ChildrenElements } from "../../globalTypes";
import {
    FormControl
} from "@chakra-ui/react";

export function FormControlEvo(data: {
    children?: ChildrenElements;
}): JSX.Element {

    return (
        <FormControl mt="2%">
            {data.children}
        </FormControl>
    );
}
